import styled from '@emotion/styled';
import { input } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

export const InputWrapper = styled('div', { label: 'InputWrapper' })`
    margin-bottom: 16px;
    width: 100%;

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const Wrapper = styled('div', { label: 'Wrapper' })`
    font-family: var(--fontFamilyPrimary);
    font-weight: ${fontWeight.medium};
    line-height: 1.4;
`;

export const CurrencyWrapper = styled('div', { label: 'CurrencyWrapper' })`
    position: absolute;
    margin-top: 5px;
    margin-left: 8px;
    width: 10px;
`;

interface InputElementPropsType {
    isError?: boolean;
    isEmpty?: boolean;
    hasLabelInside?: boolean;
    hasCurrency?: boolean;
}

export const InputElement = styled('input', { label: 'InputElement' })<InputElementPropsType>`
    background-color: ${input.bgColor};
    border-width: 1px;
    border-style: solid;
    border-color: ${({ isError, isEmpty }): string => isError === true ? input.borderColorTertiary : isEmpty === true ? input.borderColor : input.borderColorSecondary};
    color: ${input.txtColor};
    flex: 0 0 40px;
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.medium};
    height: 40px;
    line-height: 1.4;
    outline: none;
    width: 100%;
    padding: ${({ hasCurrency, hasLabelInside }): string => hasCurrency === true ? '10px 12px 10px 24px' : hasLabelInside === true ? '18px 12px 10px 12px' : '10px 12px'};

    &::placeholder {
        font-weight: ${fontWeight.regular};
        color: ${input.txtColorSecondary};
    }

    &:read-only, &:disabled {
        background-color: ${input.readOnly.bgColor};
        border-color: ${input.borderColor};
        cursor: not-allowed;
    }
`;



export const InputRow = styled('div', { label: 'InputRow' })`
    display: flex;
    align-items: flex-start;
    flex-flow: row nowrap;
`;
